import { createApi } from '@reduxjs/toolkit/query/react';
import B2ChatClient, { apiResource, b2chatBaseQuery } from '@src/client';
import { addTemplateComponentRecordProperty } from '@src/reducers/whatsAppTemplates';
import type { WhatsAppTemplate, WhatsAppTemplateState } from '@src/types';

export type GetAllWspTemplatesByBotAccountRequest = {
  botAccountId: string;
  state?: WhatsAppTemplateState;
};

export type GetAllWspTemplatesByBotAccountResponse = WhatsAppTemplate[];

export const whatsAppTemplatesApi = createApi({
  reducerPath: 'whatsAppTemplatesApi',
  baseQuery: b2chatBaseQuery,
  tagTypes: ['whatsAppTemplates'],
  endpoints: ({ query }) => ({
    // TODO: This endpoint will be used in the future for the templates table with pagination, filtering and sorting support.
    // getWspTemplatesByBotAccountPaged: query<GetWspTemplatesByBotAccountPagedResponse,GetWspTemplatesByBotAccountPagedRequest>
    // NOTE: The limit of 1,000 is set as a temporary safeguard — it is practically impossible for a bot account to reach this number of templates.
    getAllWspTemplatesByBotAccount: query<
      GetAllWspTemplatesByBotAccountResponse,
      GetAllWspTemplatesByBotAccountRequest
    >({
      providesTags: ['whatsAppTemplates'],
      keepUnusedDataFor: 0,
      query: ({ botAccountId, state }) =>
        apiResource(
          B2ChatClient.resources.templates.actions.getTemplatesByBotAccount,
          {
            params: {
              botAccountId,
              offset: 0,
              limit: 1_000,
              columnOrder: 'created_at',
              order: 'desc',
              ...(state && { states: state }),
            },
          }
        ),
      transformResponse: (response: { data: WhatsAppTemplate[] }) => {
        // Mutates in place to align with the saga path; see addTemplateComponentRecordProperty
        response.data.forEach(addTemplateComponentRecordProperty);
        return response.data;
      },
      extraOptions: { maxRetries: 1 },
    }),
  }),
});

export const {
  useGetAllWspTemplatesByBotAccountQuery,
  useLazyGetAllWspTemplatesByBotAccountQuery,
} = whatsAppTemplatesApi;
